import { Fragment } from 'react'
import { ButtonPrimary, ButtonSecondary } from '../../../../../../../../baseComponents/Button'
import { TableData } from '../../../../../../../../baseComponents/TwinTable/types'
import { OrderData } from '../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/types'
import useEditDeleteModal from '../../../../../../../../utils/hooks/useEditDeleteModal'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { getAllWorkSheetGroupStatuses, getUserPermissions } from '../../../../../../../../utils/reducers/getters'
import { DictWorkSheetProductStatusTy } from '../../../../../../../../utils/reducers/sells/workSheetGroupStatus'
import ModalProcessWorkSheetProductStatus from '../SingleWorkSheet/SingleWorkSheetInner/ModalProcessWorkSheetProductStatus'
import PermissionChecker from '../../../../../../../../baseComponents/PermissionChecker'
import { faArrowRotateRight, faTrashCan } from '@fortawesome/pro-light-svg-icons'
import { TwinIconToolTip } from '../../../../../../../../baseComponents/TwinIcon'
import ModalReopenWorkSheet from '../SingleWorkSheet/SingleWorkSheetInnerReadOnly/ModalReopenWorkSheet'
import { workSheetStatusInversed } from '@teinor/erp/types/company/order/sell/workSheet'
import { useNavigate } from 'react-router'
import ModalSmallFilled from '../../../../../../../../baseComponents/ModalsLayouts/ModalSmallFilled'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import locations from '../../../../../../../../utils/globals/locations'
import { useFetchJSON } from '../../../../../../../../utils/hooks/useFetchJson'
import ModalMultipleMatchProductWorkSheet from '../../../../../../../../specificComponents/inputTableLayouts/order/WorkSheetLayout/ModalsWorkSheetLayout/ModalMultipleMatchProductWorkSheet'
import ModalPrintMultipleWorkSheetTags from '../../../../../../../../specificComponents/inputTableLayouts/order/WorkSheetLayout/ModalsWorkSheetLayout/ModalPrintMultipleWorkSheetTags'


export interface WorkSheetButtonsProps {
    onSubmit: () => void
    completeData: OrderData
    getCompleteData: (inputtable?: TableData) => Promise<void>
    handleChangeView: () => void
}

const WorkSheetButtons: React.FC<WorkSheetButtonsProps> = ({ completeData, getCompleteData, handleChangeView }) => {
    const { t } = useTwinTranslation()
    const WorkSheetId = completeData?.header?.id
    const workSheetProductStatuses = getAllWorkSheetGroupStatuses()
    return (
        <div className='flex ml-auto order_config_buttons_parent justify-start flex-wrap items-center gap-x-15 gap-y-10 work_sheet_config_buttons'>
            <WorkSheetDeleteButton title={t('deleteWorkSheet', 'Eliminar hoja de trabajo')} id='reopenWorkSheet' WorkSheetId={completeData?.header?.id} onSubmit={getCompleteData} />
            <WorkSheetChangeStatusView title={t('changeView', 'Cambiar vista')} handleChangeView={handleChangeView} WorkSheetId={WorkSheetId} workSheetProductStatuses={workSheetProductStatuses?.dictWorkSheetGroupStatus?.[completeData?.header?.WorkSheetGroupStatusId]?.WorkSheetProductStatusesDict || {}} />
            <WorkSheetProcessingButton title={t('processingWorkSheetStatus', 'Procesar estado')} completeData={completeData} getCompleteData={getCompleteData} />
        </div>
    )
}

export const WorkSheetButtonsFinished: React.FC<WorkSheetButtonsProps> = ({ completeData, getCompleteData, handleChangeView }) => {
    const { t } = useTwinTranslation()
    const WorkSheetId = completeData?.header?.id
    const workSheetProductStatuses = getAllWorkSheetGroupStatuses()
    return (
        <div className='flex items-center relative gap-5 flex-wrap-reverse ml-auto'>
            <div className='flex justify-start flex-wrap-reverse items-center gap-15 work_sheet_config_buttons'>
                {completeData?.header?.active === false ? <WorkSheetReactiveButton title={t('ReactiveWorkSheet', 'Reactivar hoja de trabajo')} id='reactiveWorkSheet' WorkSheetId={completeData?.header?.id} onSubmit={getCompleteData} /> : <WorkSheetReopenButton title={t('ReopenWorkSheet', 'Reabrir hoja de trabajo')} id='reopenWorkSheet' WorkSheetId={completeData?.header?.id} onSubmit={getCompleteData} />}
                <WorkSheetChangeStatusView title={t('changeView', 'Cambiar vista')} handleChangeView={handleChangeView} WorkSheetId={WorkSheetId} workSheetProductStatuses={workSheetProductStatuses?.dictWorkSheetGroupStatus?.[completeData?.header?.WorkSheetGroupStatusId]?.WorkSheetProductStatusesDict || {}} />
            </div>
        </div>
    )
}

interface WorkSheetProcessingButtonProps {
    title: string
    children?: React.ReactNode
    completeData: OrderData
    getCompleteData: (inputtable?: TableData) => Promise<void>
}

const WorkSheetProcessingButton: React.FC<WorkSheetProcessingButtonProps> = ({ title, completeData, getCompleteData }) => {
    const { openModal, setOpenModal } = useEditDeleteModal()
    return (
        <Fragment>
            <ButtonPrimary id={'workSheet' + completeData?.header?.id} onClick={() => setOpenModal({ type: 'create', allRowData: { completeData } })}>{title}</ButtonPrimary>
            {openModal?.type === 'create' ? <ModalProcessWorkSheetProductStatus setOpenModal={setOpenModal} completeData={completeData} getCompleteData={getCompleteData} allRowData={openModal.allRowData} /> : null}
            {openModal?.type === 'delete' ? <ModalPrintMultipleWorkSheetTags allRowData={openModal.allRowData} setOpenModal={setOpenModal} onSubmit={() => getCompleteData()} /> : null}
            {openModal?.type === 'edit' ? <ModalMultipleMatchProductWorkSheet allRowData={openModal.allRowData} setOpenModal={setOpenModal} getData={getCompleteData} /> : null}
        </Fragment>
    )
}

interface WorkSheetChangeStatusViewProps {
    title: string
    handleChangeView: () => void
    WorkSheetId: number
    workSheetProductStatuses: DictWorkSheetProductStatusTy
}

export const WorkSheetChangeStatusView: React.FC<WorkSheetChangeStatusViewProps> = ({ title, WorkSheetId, handleChangeView, workSheetProductStatuses }) => {
    if (!workSheetProductStatuses) {
        return null
    }
    return (
        <Fragment>
            <ButtonSecondary id={'workSheetStatusView' + WorkSheetId} onClick={handleChangeView} className='ml-auto'>{title}</ButtonSecondary>
        </Fragment>
    )
}

interface WorkSheetReopenButtonProps {
    onSubmit?: () => void
    id: string
    title: string
    WorkSheetId: number
}

export const WorkSheetReopenButton: React.FC<WorkSheetReopenButtonProps> = ({ WorkSheetId, onSubmit, id, title }) => {
    const { openModal, setOpenModal } = useEditDeleteModal()
    return (
        <PermissionChecker permission='update' userPermissions={getUserPermissions('sell.workSheetProductStatus')}>
            <TwinIconToolTip classNameIcon='hover:text-green-43 regular22' message={title} icon={faArrowRotateRight} id={id} onClick={() => setOpenModal({ allRowData: { id: WorkSheetId, status: workSheetStatusInversed['working'] }, type: 'edit' })} />
            {openModal?.type === 'edit' ? <ModalReopenWorkSheet setOpened={() => setOpenModal(null) } onSubmit={() =>onSubmit?.()} allRowData={openModal.allRowData} /> : null}
        </PermissionChecker>
    )
}

interface WorkSheetReactiveButtonProps {
    onSubmit?: () => void
    id: string
    title: string
    WorkSheetId: number
}

export const WorkSheetReactiveButton: React.FC<WorkSheetReactiveButtonProps> = ({ WorkSheetId, onSubmit, id, title }) => {
    const { openModal, setOpenModal } = useEditDeleteModal()
    return (
        <PermissionChecker permission='update' userPermissions={getUserPermissions('sell.workSheetProductStatus')}>
            <TwinIconToolTip classNameIcon='hover:text-green-43 regular22' message={title} icon={faArrowRotateRight} id={id} onClick={() => setOpenModal({ allRowData: { id: WorkSheetId, active: true }, type: 'edit' })} />
            {openModal?.type === 'edit' ? <ModalReactiveWorkSheet setOpened={() => setOpenModal(null) } onSubmit={() =>onSubmit?.()} allRowData={openModal.allRowData} /> : null}
        </PermissionChecker>
    )
}
interface WorkSheetDeleteButtonProps {
    onSubmit?: () => void
    id: string
    title: string
    WorkSheetId: number
}

export const WorkSheetDeleteButton: React.FC<WorkSheetDeleteButtonProps> = ({ WorkSheetId, onSubmit, id, title }) => {
    const { openModal, setOpenModal } = useEditDeleteModal()
    return (
        <PermissionChecker permission='delete' userPermissions={getUserPermissions('sell.workSheetProductStatus')}>
            <TwinIconToolTip classNameIcon='hover:text-red-BA regular22' message={title} icon={faTrashCan} id={id} onClick={() => setOpenModal({ allRowData: { id: WorkSheetId }, type: 'edit' })} />
            {openModal?.type === 'edit' ? <ModalDeleteWorkSheet setOpened={() => setOpenModal(null) } onSubmit={() =>onSubmit?.()} allRowData={openModal.allRowData} /> : null}
        </PermissionChecker>
    )
}

interface ModalReactiveWorkSheetProps extends ModalEditComponentProps { }

const ModalReactiveWorkSheet: React.FC<ModalReactiveWorkSheetProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchJSON } = useFetchJSON({
        onSubmit,
        url: '/api/app/order/sell/workSheet/updateWorkSheet',
        data: { id: allRowData?.id, active: true }
    })
    return (
        <ModalSmallFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchJSON} translations={{
            title: t('sureReactiveWorkSheet', '¿Seguro que quieres reactivar esta hoja de trabajo?'),
            subtitle: t('modificableOnceReactiveed', 'Podrás modificar los datos una vez reactivada'),
            buttonAccept: t('accept', 'Aceptar'),
        }} />
    )
}

interface ModalDeleteWorkSheetProps extends ModalEditComponentProps { }

const ModalDeleteWorkSheet: React.FC<ModalDeleteWorkSheetProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const navigate = useNavigate()
    const { handleFetchJSON } = useFetchJSON({
        onSubmit,
        url: '/api/app/order/sell/workSheet/deleteWorkSheet',
        data: allRowData || {}
    })
    return (
        <ModalSmallFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={() => { handleFetchJSON(); navigate(locations.workSheets) }} translations={{
            title: t('sureDeleteWorkSheet', '¿Seguro que quieres eliminar esta hoja de trabajo?'),
            subtitle: t('onceDeactivateNotRecover', 'Una vez desactivada no podrás recuperarla'),
            buttonAccept: t('accept', 'Aceptar'),
        }} />
    )
}

export default WorkSheetButtons